const de = {
  title: 'Gruppierung',
  modal: {
    createGroupingTitle: 'Gruppierung erstellen',
    editGroupingTitle: 'Gruppierung bearbeiten',
    groupingName: 'Gruppenname',
    description: 'Beschreibung'
  },
  alerts: {
    errorLoadingGroupings: 'Gruppen konnten nicht geladen werden!',
    errorCreatingGrouping: 'Gruppe konnte nicht erstellt werden!',
    errorEditingGroupings: 'Gruppe konnte nicht geladen werden!',
    errorDeletingGrouping: 'Gruppe konnte nicht gelöscht werden!',
    successCreatingGrouping: 'Gruppe wurde erfolgreich erstellt!',
    successEditingGrouping: 'Gruppe wurde erfolgreich bearbeitet!',
    successDeletingGrouping: 'Gruppe wurde erfolgreich gelöscht!'
  },
  deleteConfirm: {
    title: 'Wirklich löschen?',
    message: 'Wollen Sie wirklich diese Gruppierung löschen?'
  }
};

export default de;
export type GroupingsTranslation = typeof de;
